module.exports = "/_next/static/images/OctoDiagram-xs@2x-5d825c44d15980c3f3acb758df7492ec.png";